import { PLANO_MENSAL } from '../../../../../constants'

export const TITULO_ASSINATURA_SUSPENSA = 'Suspensão confirmada com sucesso!'

export const getTextoConlusaoSuspensao = ( dadosKitsCobrancas, plano ) => {
  if ( plano === PLANO_MENSAL.visualizacao ) {
    return `Pulamos a cobrança do kit de ${dadosKitsCobrancas.mesSeguinteAoUltimoKitPago} para você.
    <br><br>
    A próxima cobrança será feita normalmente, a partir do dia ${dadosKitsCobrancas.dataInicioCicloCobranca} do mês anterior ao kit, referente ao kit de ${dadosKitsCobrancas.doisMesesDepoisDoUltimoKitPago}.
    <br><br>
    Até lá, seguimos por aqui preparando leituras incríveis para quando você voltar! 💙`
  }

  return `Pulamos a cobrança do kit de ${dadosKitsCobrancas.mesSeguinteAoUltimoKitPago} para você.
  <br><br>
  Adicionamos um novo kit ao final do seu plano anual, totalizando, assim, 12 caixinhas.`
}
